import {BaseMobxState} from "../../infrastructure/mobx/base-mobx-state";
import {BaseApiRequestParams} from "../../infrastructure/models/params/base-api-request-params";
import {FullGameResponseDomainService} from "../../domain/full-game/services/full-game-response.domain-service";
import {DeltaHandler} from "../../infrastructure/handlers/delta-handler";
import {FullGameRequestParams} from "../../domain/full-game/models/full-game.request-params";
import {ACTION_TYPES, COMPONENT_STATES} from "../consts";

export class FullGameFetchHandler extends DeltaHandler {
  state: BaseMobxState;

  static injectables = [FullGameResponseDomainService];

  async onLoaded() {
    await super.onLoaded();
    // const isBack: Boolean = this.historyManager.action === HISTORY_ACTIONS.pop || !!this.state.dataSource;
    //
    // if (!isBack) {
    //   this.controller.store.setComponentState(COMPONENT_STATES.loading);
    // }

    await this.action();
  }

  get requestParams(): BaseApiRequestParams {
    const gameId: Number = this.controller.props?.gameId;
    const matchupId: String = this.controller.props?.matchupId;
    const topBookmaker = this.state.appState.topBookmakerId;

    const requestParams: FullGameRequestParams = new FullGameRequestParams(gameId, matchupId, topBookmaker);

    return requestParams;
  }

  async action() {
    const dataSource = await this.fetch(this.createDomainParams(), !!this.state.dataSource);

    await this.controller.action(ACTION_TYPES.populateData, {dataSource, isDelta: true});
    this.controller.props.onWidgetVisible?.(this.state.isPopulated);

    return dataSource;
  }

  populateDelta(dataSource, params) {
    this.controller.action(ACTION_TYPES.populateData, {dataSource, isDelta: true});
  }

  async onDidUpdate(prevProps, nextProps) {
    super.onDidUpdate(prevProps, nextProps);

    const matchupIdChange: Boolean = prevProps.matchupId !== nextProps.matchupId;
    const gameIdChanged: Boolean = prevProps.gameId !== nextProps.gameId;

    if (gameIdChanged || matchupIdChange) {
      this.controller.store.setComponentState(COMPONENT_STATES.loading);
      // await this.controller.action(ACTION_TYPES.populateData, nextProps.location?.state);

      await this.action();
    }
  }
}
